import Subscription from '../modules/Profile/Subscription';
import ProfileLayout from '../modules/Profile/ProfileLayout';
import { CustomNextPage } from '../lib/types';
import { profilePageQuery } from '../core-types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { bootstrap } from '../lib/bootstrap';
import MissingOnboardingDialog from '../modules/MissingOnboardingDialog';
import { useCurrentUser } from '../lib/core/useCurrentUser';
import { SubmitEmailStep } from '../modules/SubmitEmailStep';
import { Flex } from '@urbaninfrastructure/react-ui-kit';
import router from 'next/router';

const ProfilePage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { currentUser } = useCurrentUser();
  const { url, statusCode } = props;
  return (
    <ProfileLayout statusCode={statusCode} url={url}>
      {({ profilePage, system }) => {
        if (
          system.userEmailConfirmationRequired &&
          !currentUser?.emailConfirmed
        ) {
          return (
            <Flex
              justifyContent={'center'}
              alignItems={'center'}
              height={'100vh'}
            >
              <SubmitEmailStep
                goNext={() => {
                  router.push('/profile');
                }}
              />
            </Flex>
          );
        }
        return (
          <>
            <MissingOnboardingDialog />
            <Subscription profilePage={profilePage} system={system} />
          </>
        );
      }}
    </ProfileLayout>
  );
};

ProfilePage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (!profilePageQueryResult.data?.profilePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(ProfilePage);
